import { CustomLink } from "@/components/CustomLink";
import { getRelativePathFromLink } from "@/utils/url";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import React from "react";
import styles from "./SearchMenuItem.module.scss";
import { CustomSVG } from "@/components/_primitives/CustomSVG/CustomSVG";
interface SearchProps {
  searchPageSlug: string;
  isMobileNavigation?: boolean;
  hasBackground?: boolean;
}
function SearchMenuItem({
  searchPageSlug,
  isMobileNavigation,
  hasBackground,
}: SearchProps) {
  searchPageSlug = searchPageSlug
    ? getRelativePathFromLink(searchPageSlug).replace(/\//g, "")
    : "/search";
  const { getIcon, getLabel } = useGlobalContext();
  return (
    <div
      className={
        styles["search-menu-item-wrapper"] + " search-menu-item-wrapper"
      }
    >
      <CustomLink
        // role="menuitem"
        href={searchPageSlug}
        target="_self"
        className={`${styles["search-menu-item"]} navbar-sublink ${hasBackground ? "" : styles["without-background"]}`}
        aria-label={getLabel("go_to_search_page") || "Go to search page"}
      >
        {isMobileNavigation && (
          <span>{getLabel("search_navigation_label", "Suche")}</span>
        )}

        <CustomSVG
          src={getIcon("search")}
          width={24}
          height={24}
          wrapper={"span"}
          aria-hidden="true"
          className="is-flex"
        />
      </CustomLink>
    </div>
  );
}

export default SearchMenuItem;
